import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { TradingAccount } from '../../proto/generated/trading-bridge'
import { BrokerId, generateBrokerLoginUrl, getBrokerId, keyValueArrayFromTradingAccountParams } from '../../util/tradingAccounts'

interface Props {
    primaryTradingAccount: TradingAccount | null
}

export default function ReconnectTradingAccount({ primaryTradingAccount}: Props) {
    const navigate = useNavigate()

    const handleClick = async () => {
        if (!primaryTradingAccount) {
            void navigate('/trading-account')
            return
        }
        const { brokerCode, tradingAccountParameters } = primaryTradingAccount
        if (brokerCode === BrokerId.DHAN) {
            void navigate(`/trading-account/${brokerCode}`)
        } else {
            const loginUrl = await generateBrokerLoginUrl(getBrokerId(brokerCode), keyValueArrayFromTradingAccountParams(tradingAccountParameters))
            void window.open(loginUrl, '_self')
        }
    }

    return (
        <Button
            sx={{ mt: 2, width: '40%' }}
            variant="contained"
            color="inherit"
            onClick={() => {
                void handleClick()  
            }}
        >
            {primaryTradingAccount? 'Reconnect' : 'Connect'}
        </Button>
    )
}
